/**
 * Accuracy types for traits
 */
export enum AccuracyType {
  Linked = 0,
  NotAccurate = 1,
  NotLinked = 2
}
